// extracted by mini-css-extract-plugin
export default {"paper":"events_paper__3CGP8","modal":"events_modal__7BbAC","root":"events_root__0vwJI","backdrop":"events_backdrop__NRbJ2","cssRoot":"events_cssRoot__gYUut"};